import { useState } from "react";
import { updatePrice } from "../../http/priceListAPI";

function BannerChanges() {
    const [price, setPrice] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async () => {
        if (!price) {
            setError("Пожалуйста, выберите файл");
            return;
        }

        setIsLoading(true);
        setError(null);

        try {
            const formData = new FormData();
            formData.append("file", price);
            await updatePrice(formData);
            alert("Прайс-лист успешно загружен");
        } catch (err) {
            setError("Ошибка при загрузке файла");
        } finally {
            setIsLoading(false);
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type !== "application/pdf") {
            setError("Пожалуйста, выберите PDF-файл");
            return;
        }
        setPrice(file);
        setError(null);
    };

    return (
        <div style={{ padding: "20px", maxWidth: "500px" }}>
            <h3>Обновление прайс-листа</h3>
            
            <input
                type="file"
                accept=".pdf"
                onChange={handleFileChange}
                disabled={isLoading}
                style={{ marginBottom: "10px" }}
            />
            
            <br />
            
            <button 
                onClick={handleSubmit}
                disabled={!price || isLoading}
                style={{
                    padding: "8px 16px",
                    backgroundColor: "#4CAF50",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer"
                }}
            >
                {isLoading ? "Загрузка..." : "Загрузить новый прайс-лист"}
            </button>
            
            {error && (
                <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
            )}
        </div>
    );
}

export default BannerChanges;